module.exports = __webpack_public_path__ + "static/media/Abhay Gaikwad.4cf5cbcc.jpg";